export const SELECTION_TOGGLE_FALLBACK_TIMEOUT = 30000;
export const GLOBAL_CLIENT_FETCH_TIMEOUT = 10000;